import './style.scss'
import { default as Area , getDistrictName } from '../'

export default {
  name:'AreaSelect',
  props:['value'],
  data(){
    return {
      visible:false,
      current:null,
      currentId:null,
      currentIdx:null,
      currentLabel:null,
      selected:[]
    }
  },
  created(){
    this.$watch('value' , function(nv){
      if(nv && Array.isArray(nv)) this.selected = nv
      else this.selected = []
    },{immediate:true})
  },
  methods:{

    handleClick(){
      this.visible = true
    },
    handleOutSide(){
      this.visible = false
    },

    handleRemove(idx,e){
      this.selected.splice(idx,1)
      e.stopPropagation()
    },
    renderResult(){
      let { currentIdx } = this
      let selected = this.selected.map(i => ({code:i , name:getDistrictName(i , '/')}))
      return selected.map((i,idx) => (
        <div on-click={(e) => this.handleClickItem(i,idx,e)} class={{"result-item":1,'actived':idx == currentIdx}}><span>{i.name}</span><span class="sl-city-select-remove" on-click={e => this.handleRemove(idx,e)}><Icon type="ios-close" /></span></div>
      ))
    },
    handleClickItem(i , idx , e){
      if( this.currentId  ){
        this.currentId = i.code
        this.currentIdx = idx
        e.stopPropagation()
      }else{
        this.currentId = i.code
        this.currentIdx = idx
      }
    },
    /*
     * xx xx xx
     * yy yy yy
     *  1  1  1
     */
    checkUnique(v){
      let prop = String(v[v.length-1]).match(/\d{2}/g)
      // let props = [prop.replace(/0+$/,'') , prop.substring(0,4) + '00' , prop.substring(0,2) + '0000']

      let selected = this.selected.filter(i => i != this.currentId).map(i => String(i).match(/\d{2}/g))
      for(let i of selected){
        if( 
          i[0] == prop[0] && 
          ( i[1] == prop[1] || i[1] == '00' || prop[1] == '00' ) && 
          ( i[2] == prop[2] || i[2] == '00' || prop[2] == '00' ) 
        ) {
          this.$Message.error('与 '+ (getDistrictName(i.join('') , '/')) + ' 区域重叠')
          return false
        }
      }

      
      return true
    },
    handleCreate(v){
      //if( this.checkUnique(v.map(i => i.code)) ){
        //编辑模式
        if( this.currentIdx !== null){
          if( this.checkUnique(v.map(i => i.code)) ){
            this.selected[this.currentIdx] = v[v.length-1]['code']
          }
        }else{
          this.currentLabel = v.map(i => i.name).join('/')
          this.current = v
        }
      //}
    },
    handleRemoveCurrent(){
      this.current = null
      this.currentLabel = null
      this.currentId = null
      this.currentIdx = null
    },
    hancleChange(){
      let v = this.current
      this.currentId = null
      this.currentIdx = null

      if(!v) return

      if( this.checkUnique(v.map(i => i.code)) ){

        let code = v[v.length-1]['code']

        this.selected.push(code)

        this.current = null
        this.currentLabel = null
        this.emit()
      }else{
        this.current = null
        this.currentLabel = null
      }

    },
    emit(){
      this.$emit('change',this.selected)
    }
  },
  render(){
    return (
       <Area value={this.currentId} slient={true} on-select={this.handleCreate} on-change-data={this.hancleChange} >
         <div v-click-outside={this.handleOutSide} class={{"sl-city-select":1 , 'visible':this.visible}}>
          <div class="sl-city-select-result" on-click={this.handleClick}>
            { this.renderResult() }
            { this.currentLabel ? <div class="result-item actived"><span>{this.currentLabel}</span><span class="sl-city-select-remove" on-click={e => this.handleRemoveCurrent()}><Icon type="ios-close" /></span></div> : null }
          </div>
        </div>
       </Area>
      
    )
  }
}